import presetListViewTemplate from '../../../../../Template/config/components/selection/PresetSelect'
import presetListView from './PresetListView'
const presetSelect = {
  ...presetListViewTemplate,
  presetListView
}

export default presetSelect
export { presetSelect }



// WEBPACK FOOTER //
// ./src/app/configuration/ComcastOffer/config/components/selection/PresetSelect/index.js